import type { StaticDevicesFilters } from '@/api/routes/static-devices/types';

export const staticDevicesFilters: StaticDevicesFilters = {
  org: [],
  adv: [],
  profile: [],
  park: [],
  operator: [],
  tag: [],
  device: [],
};
